export const myAccountConstants = {
    DASHBOARD: 'DASHBOARD',
    ORDERS: 'ORDERS',
    USER_SETTINGS: 'USER_SETTINGS',
    SAVED_DESIGNS: 'SAVED_DESIGNS',
    ADDRESS_BOOK: 'ADDRESS_BOOK',
};